import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseRoute: string;
  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.rootAPI;
  }

  getUserDatabyId<T>(id: number): Observable<T> {
    return this.httpClient.get<T>(`${environment.formbuilderAPIUrlRoot}/getdatabyid/${id}`);
  }

  getMerchant<T>(id: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}account/api/merchantowner/getbyid?id=${id}`);
  }
}
